function _t(translation) {
    if (!euPortalConfig || !euPortalConfig.translations) {
        return '';
    }

    return euPortalConfig.translations[translation] || '';
}

module.exports = _t;
